import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "full-width" }
const _hoisted_2 = { class: "row no-wrap full-width" }
const _hoisted_3 = {
  key: 0,
  class: "q-mr-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_formula_selector = _resolveComponent("formula-selector")!
  const _component_dnd_reorder_element = _resolveComponent("dnd-reorder-element")!

  return (_openBlock(), _createBlock(_component_dnd_reorder_element, {
    id: undefined,
    index: _ctx.inputIndex,
    "highlight-condition": _ctx.allowHoverAction,
    "hover-condition": () => false,
    CtcDropCondition: _ctx.allowHoverAction,
    CtrDropCondition: () => false,
    RtrDropCondition: () => false,
    type: _ctx.elDragType,
    "into-allowed": false,
    "callback-params": { elType: 5, innerElementId: this.theModel.Id, viewport: _ctx.scrollViewport, isEditing: _ctx.isEditing },
    onChangePosition: _ctx.moveStoreItem,
    draggable: !_ctx.isEditing,
    class: "dnd-element display-ungroup-on-hover"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.inputIndex != null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString((_ctx.inputIndex+1)+'.'), 1))
            : _createCommentVNode("", true),
          (!_ctx.isEditing)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(['q-my-none', 'cursor-pointer', 
          { 'text-grey-8': !(_ctx.theModel as CommonEntity).Name }]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startEditing && _ctx.startEditing(...args)))
              }, _toDisplayString((_ctx.theModel as CommonEntity).Name), 3))
            : (_openBlock(), _createBlock(_component_q_input, {
                key: 2,
                ref: "fname_input",
                class: "thin-input-noborder full-width",
                clearable: "",
                autofocus: "",
                color: "white",
                debounce: "500",
                "clear-icon": "close",
                outlined: "",
                dense: "",
                style: {"font-size":"12px !important","padding":"0 !important","margin-top":"-3px"},
                "hide-bottom-space": "",
                modelValue: (_ctx.theModel as CommonEntity).Name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (((_ctx.theModel as CommonEntity).Name) = $event)),
                "no-error-icon": "",
                onKeydown: [
                  _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.isEditing = false), ["esc"])),
                  _withKeys(_withModifiers(_ctx.editItem, ["stop","prevent"]), ["enter"])
                ],
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isEditing = false))
              }, null, 8, ["modelValue", "onKeydown"])),
          (!_ctx.isEditing)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 3,
                class: "q-px-none q-mx-none unset-items-center",
                flat: "",
                dense: "",
                "aria-label": _ctx.$t('delete_formula'),
                icon: "close",
                size: "sm",
                style: {"margin-top":"-2px"},
                tabindex: "-1",
                color: "accent",
                onClick: _ctx.deleteFormula
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, { delay: 1000 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["aria-label", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.useChartMode)
          ? (_openBlock(), _createBlock(_component_formula_selector, {
              key: 0,
              class: "full-width",
              "input-index": _ctx.inputIndex,
              "nested-key-name": _ctx.nestedKeyName,
              "template-name": _ctx.templateName,
              "global-formulas-mode": true,
              "input-parameter-options": _ctx.parameterOptions,
              "formula-options": [],
              "is-incorrect": _ctx.isIncorrect,
              modelValue: (this.theModel as AnalyticsChartElementFormula).Tokens,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (((this.theModel as AnalyticsChartElementFormula).Tokens) = $event)),
              onTheOnlyFormulaLeft: _ctx.updateElementName
            }, null, 8, ["input-index", "nested-key-name", "template-name", "input-parameter-options", "is-incorrect", "modelValue", "onTheOnlyFormulaLeft"]))
          : (_openBlock(), _createBlock(_component_formula_selector, {
              key: 1,
              class: "full-width",
              "nested-key-name": "RecordFields",
              "input-index": _ctx.inputIndex,
              "formula-options": _ctx.formulaOptions,
              "input-parameter-options": undefined,
              "is-incorrect": _ctx.isIncorrect,
              modelValue: (this.theModel as AnalyticsTableFormula).FormulaTokens,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (((this.theModel as AnalyticsTableFormula).FormulaTokens) = $event))
            }, null, 8, ["input-index", "formula-options", "is-incorrect", "modelValue"]))
      ])
    ]),
    _: 1
  }, 8, ["index", "highlight-condition", "CtcDropCondition", "type", "callback-params", "onChangePosition", "draggable"]))
}